module.exports = __webpack_public_path__ + "static/scale-model-of-segs-in-the-city-in-alexandria-virginia-bde78dc5ad464a00d49dacfc0342ed13.png";